export default __webpack_public_path__ + "1094d2986ef1a7aa6a1bb8a596a6eede.svg";